// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Ads__WebModalController from "./ads/web_modal_controller"
application.register("ads--web-modal", Ads__WebModalController)

import Athletes__FormController from "./athletes/form_controller"
application.register("athletes--form", Athletes__FormController)

import Athletes__VideoEntriesController from "./athletes/video_entries_controller"
application.register("athletes--video-entries", Athletes__VideoEntriesController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CategoryMatchMatrixController from "./category_match_matrix_controller"
application.register("category-match-matrix", CategoryMatchMatrixController)

import Coaches__FormController from "./coaches/form_controller"
application.register("coaches--form", Coaches__FormController)

import Coaches__TemplateDropdownController from "./coaches/template_dropdown_controller"
application.register("coaches--template-dropdown", Coaches__TemplateDropdownController)

import Shared__AutoRefreshController from "./shared/auto_refresh_controller"
application.register("shared--auto-refresh", Shared__AutoRefreshController)

import Shared__CleanupController from "./shared/cleanup_controller"
application.register("shared--cleanup", Shared__CleanupController)

import Shared__CollapsibleCardController from "./shared/collapsible_card_controller"
application.register("shared--collapsible-card", Shared__CollapsibleCardController)

import Shared__DropdownController from "./shared/dropdown_controller"
application.register("shared--dropdown", Shared__DropdownController)

import Shared__DropzoneController from "./shared/dropzone_controller"
application.register("shared--dropzone", Shared__DropzoneController)

import Shared__FancyMultiselectController from "./shared/fancy_multiselect_controller"
application.register("shared--fancy-multiselect", Shared__FancyMultiselectController)

import Shared__FancySelectController from "./shared/fancy_select_controller"
application.register("shared--fancy-select", Shared__FancySelectController)

import Shared__ModalController from "./shared/modal_controller"
application.register("shared--modal", Shared__ModalController)

import Shared__RangeSliderController from "./shared/range_slider_controller"
application.register("shared--range-slider", Shared__RangeSliderController)

import Shared__ScrollspyController from "./shared/scrollspy_controller"
application.register("shared--scrollspy", Shared__ScrollspyController)

import Showcases__FormController from "./showcases/form_controller"
application.register("showcases--form", Showcases__FormController)

import TippyController from "./tippy_controller"
application.register("tippy", TippyController)
